/**
 * 환경변수 설정 유틸리티
 */

export type EnvConfig = {
  BASE_URL: ImportMetaEnv['VITE_BASE_URL'];
  DOMAIN: ImportMetaEnv['VITE_DOMAIN'];
  GOOGLE_CLIENT_ID: ImportMetaEnv['VITE_GOOGLE_CLIENT_ID'];
  MICROSOFT_CLIENT_ID: ImportMetaEnv['VITE_MICROSOFT_CLIENT_ID'];
  MEGAZONE_CLIENT_ID: ImportMetaEnv['VITE_MEGAZONE_CLIENT_ID'];
  MODE: ImportMetaEnv['VITE_MODE'];
  CUSTOM_ROOT_CATEGORY: ImportMetaEnv['VITE_CUSTOM_ROOT_CATEGORY'];
  INTRODUCTION_PAGE: ImportMetaEnv['VITE_ENABLE_INTRODUCTION_PAGE'];
  ONLY_USE_LOGIN_PAGE: ImportMetaEnv['VITE_ENABLE_ONLY_EMPLOYEE_LOGIN_PAGE'];
  THEME_TYPE: ImportMetaEnv['VITE_THEME_TYPE'];
  COMPANY_ID: ImportMetaEnv['VITE_COMPANY_ID'];
  CUSTOM_TRANSLATION: ImportMetaEnv['VITE_ENABLE_CUSTOM_TRANSLATION'];
  // White-labeling
  APP_TITLE: ImportMetaEnv['VITE_APP_TITLE'];
  APP_DESCRIPTION: ImportMetaEnv['VITE_APP_DESCRIPTION'];
  FAVICON_PATH: ImportMetaEnv['VITE_FAVICON_PATH'];
  MANIFEST_PATH: ImportMetaEnv['VITE_MANIFEST_PATH'];
  THEME_COLOR: ImportMetaEnv['VITE_THEME_COLOR'];
  APPLE_TOUCH_ICON_PATH: ImportMetaEnv['VITE_APPLE_TOUCH_ICON_PATH'];
  PASS_TENANT_SELECT_PAGE: ImportMetaEnv['VITE_PASS_TENANT_SELECT_PAGE'];
  SMP_PROVIDER_NAME: ImportMetaEnv['VITE_SMP_PROVIDER_NAME'];
  ENABLED_PRIVACY_POLICY: ImportMetaEnv['VITE_ENABLED_PRIVACY_POLICY'];
  ENABLED_USER_LOGIN_CASE: ImportMetaEnv['VITE_ENABLED_USER_LOGIN_CASE'];
  DISABLE_PASSWORD_LOGIN: ImportMetaEnv['VITE_DISABLE_PASSWORD_LOGIN'];
  SHOW_SSO_AS_DEFAULT: ImportMetaEnv['VITE_SHOW_SSO_AS_DEFAULT'];
};

/**
 * 모든 환경변수를 반환하는 유틸리티 함수
 * @returns 환경변수 객체
 */
export const getEnvConfig = (): EnvConfig => {
  const config = {
    BASE_URL: import.meta.env.VITE_BASE_URL,
    DOMAIN: import.meta.env.VITE_DOMAIN,
    GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
    MICROSOFT_CLIENT_ID: import.meta.env.VITE_MICROSOFT_CLIENT_ID,
    MEGAZONE_CLIENT_ID: import.meta.env.VITE_MEGAZONE_CLIENT_ID,
    MODE: import.meta.env.VITE_MODE,
    CUSTOM_ROOT_CATEGORY: import.meta.env.VITE_CUSTOM_ROOT_CATEGORY,
    INTRODUCTION_PAGE: import.meta.env.VITE_ENABLE_INTRODUCTION_PAGE,
    ONLY_USE_LOGIN_PAGE: import.meta.env.VITE_ENABLE_ONLY_EMPLOYEE_LOGIN_PAGE,
    THEME_TYPE: import.meta.env.VITE_THEME_TYPE,
    COMPANY_ID: import.meta.env.VITE_COMPANY_ID,
    CUSTOM_TRANSLATION: import.meta.env.VITE_ENABLE_CUSTOM_TRANSLATION,
    // White-labeling with defaults
    APP_TITLE: import.meta.env.VITE_APP_TITLE || 'Splitter',
    APP_DESCRIPTION: import.meta.env.VITE_APP_DESCRIPTION || 'Enterprise Subscription Service',
    FAVICON_PATH: import.meta.env.VITE_FAVICON_PATH || '/favicon.ico',
    MANIFEST_PATH: import.meta.env.VITE_MANIFEST_PATH || '/manifest_smp_admin_console.json',
    THEME_COLOR: import.meta.env.VITE_THEME_COLOR || '#5A32A3',
    APPLE_TOUCH_ICON_PATH: import.meta.env.VITE_APPLE_TOUCH_ICON_PATH || '/apple-touch-icon.png',
    PASS_TENANT_SELECT_PAGE: import.meta.env.VITE_PASS_TENANT_SELECT_PAGE || 'false',
    SMP_PROVIDER_NAME: import.meta.env.VITE_SMP_PROVIDER_NAME || 'MEGAZONE',
    ENABLED_PRIVACY_POLICY: import.meta.env.VITE_ENABLED_PRIVACY_POLICY || 'false',
    ENABLED_USER_LOGIN_CASE: import.meta.env.VITE_ENABLED_USER_LOGIN_CASE || '',
    DISABLE_PASSWORD_LOGIN: import.meta.env.VITE_DISABLE_PASSWORD_LOGIN || 'false',
    SHOW_SSO_AS_DEFAULT: import.meta.env.VITE_SHOW_SSO_AS_DEFAULT || 'false',
  };

  return config;
};
